import React, { useContext } from 'react';
import UPaper from 'components/UPaper';
import {
  Chip, makeStyles, Fade, Tooltip,
} from '@material-ui/core';
import FilterListIcon from '@material-ui/icons/FilterList';
import { FiltrosContext } from '../Context/filtros';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    padding: theme.spacing(1, 2),
  },
  filterIcon: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(2),
  },
  filterIconContainer: {
    display: 'flex',
    height: '48px',
    justifyContent: 'center',
    alignItems: 'center',
  },
  chipContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    listStyle: 'none',
    padding: theme.spacing(0.5),
    margin: 0,
  },
  chip: {
    margin: theme.spacing(0.5),
  },
}));

function Filtros() {
  const classes = useStyles();
  const { visible, filtros } = useContext(FiltrosContext);

  return (
    <Fade in={visible && filtros.length > 0} unmountOnExit>
      <div>
        <UPaper className={classes.root} fullWidth>
          <Tooltip
            title="Filtros aplicados"
            aria-label="filtros aplicados"
          >
            <div className={classes.filterIconContainer}>
              <FilterListIcon className={classes.filterIcon} />
            </div>
          </Tooltip>
          <ul className={classes.chipContainer}>
            {filtros && filtros.map((filtro) => (
              <li key={filtro.label}>
                <Chip
                  color="primary"
                  className={classes.chip}
                  label={`${filtro.label}: ${filtro.value}`}
                />
              </li>
            ))}
          </ul>
        </UPaper>
      </div>
    </Fade>
  );
}

export default Filtros;
